import { Text, TextProps } from '@chakra-ui/react';

type Props = TextProps & {
  count: number;
};

const UnreadCountBubble = ({ count, ...props }: Props) => {
  if (count <= 0) {
    return null;
  }

  return (
    <Text
      w="16px"
      h="16px"
      rounded="full"
      bg="redPure"
      color="white"
      fontSize="9px"
      fontWeight="800"
      lineHeight="16px"
      textAlign="center"
      zIndex={10}
      {...props}
    >
      {count}
    </Text>
  );
};

export default UnreadCountBubble;
